<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'MATERIAL.ENTER_SITEWELLAWAREID' | translate | uppercase }}</div>
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <input type="text" [(ngModel)]="siteWellawareId">

    <div class="footer">
      <button (click)="addSiteWellawareId()" [disabled]="!isValid()">{{ 'CONFIRM' | translate | uppercase }}</button>
    </div>
      
  </div>
</div>